import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveyCustomerService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllSurveyCustomer(page,size){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.SurveyCustomer,
      queryString:`Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async createSurveyCustomer(companyId,surveyId,mail){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.SurveyCustomer
    },
    {
      companyId:companyId,
      surveyId:surveyId,
      mail:mail
    });
    return await firstValueFrom(observable);
  }

  async getCodeSurveyCustomer(code:string){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.SurveyCustomer
    },code);
    return await firstValueFrom(observable);
  }
}
